// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__15mGs","balanceDisclaimer":"posDashboard_balanceDisclaimer__1lIzP"};